import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BaseResourceService } from '../../models/services/base-resource.service';
import { TermoAcesso } from '../../entidade/comum/termo-acesso.model';

@Injectable({
  providedIn: 'root'
})
export class TermoAcessoService extends BaseResourceService<TermoAcesso> {

  constructor(
    protected injector: Injector
  ) {
    super(`termo-acessos`, injector);
  }

  public obter(filtros?: {}, cidade?: number): Observable<TermoAcesso> {
    let parametros = '';
    if (filtros) {
      // tslint:disable-next-line: forin
      for (const key in filtros) {
        if (parametros === '') {
          parametros += '?';
        } else {
          parametros += '&';
        }
        parametros += key + '=' + filtros[key];
      }
    }
    return this.http.get<TermoAcesso>(
      `${(cidade ? cidade : this.login.cidade.id)}/${this.api}/obter${parametros}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }
}
